/**
 * Sunucudaki SabitGelirHesap.Paylar ile aynı: paylar 2 haneye yuvarlanır, oranlar %100 ise kuruş farkı son satıra eklenir.
 * Ekranda anlık önizleme içindir; kesin tutar sunucuda hesaplanır.
 */
export const sabitGelirPaylari = (bedel: number, oranlar: number[]) => {
    const yuvarla = (x: number) => Math.sign(x) * Math.round(Math.abs(x) * 100 + 1e-9) / 100;
    const paylar = oranlar.map(o => yuvarla(bedel * o / 100));
    const toplamOran = oranlar.reduce((a, b) => a + b, 0);

    if (paylar.length > 0 && Math.abs(toplamOran - 100) < 0.0001)
        paylar[paylar.length - 1] = yuvarla(paylar[paylar.length - 1] + yuvarla(bedel) - paylar.reduce((a, b) => a + b, 0));

    return paylar;
}
